import { useSelector } from "@legendapp/state/react";
import { VideoPlayer } from "./video-player";
import { useViewSettings } from "@/view-settings";

export function VideoPlayerContainer() {
  const viewSettings = useViewSettings();

  const isEnabled = useSelector(() => viewSettings.showVideo.get());

  if (!isEnabled) {
    return null;
  }

  return <VideoPlayer />;
}
